import {
  type InitResult,
  type Env,
  type Payment,
} from '@airwallex/components-sdk'

const getBaseConfig = () => {
  const runtime = useRuntimeConfig()
  return <Partial<Payment.HostPaymentPage>>{
    env: runtime.public.airwallexEnv as Env,
    withBilling: true,
    locale: !isChinese() ? 'en' : 'zh-CN',
    showTermLink: true,
  }
}

export function hpp(
  mode: 'payment' | 'recurring',
  options: Payment.HostPaymentPage
) {
  const $airwallex = useNuxtApp().$airwallex as InitResult

  const payments = $airwallex?.payments
  if (!payments) {
    return
  }

  const redirectHppForCheckout = () => {
    const link = payments?.redirectToCheckout({
      mode: 'payment',
      ...getBaseConfig(),
      successUrl: location.origin + '/paymentResult',
      failUrl: location.origin + '/paymentResult',
      requiredBillingContactFields: ['country_code', 'email', 'name'],
      // For more detailed documentation at https://github.com/airwallex/airwallex-payment-demo/tree/master/docs#redirectToCheckout
      ...options,
    })
    if (options.disableAutoRedirect && link) {
      window.open(link)
    }
  }

  const redirectHppForRecurring = () => {
    const link = payments?.redirectToCheckout({
      mode: 'recurring',
      ...getBaseConfig(),
      requiredBillingContactFields: ['country_code', 'email', 'name'],
      recurringOptions: {
        card: {
          next_triggered_by: 'merchant',
          merchant_trigger_reason: 'scheduled',
          currency: options.currency,
        },
      },
      successUrl: location.origin + '/paymentResult',
      failUrl: location.origin + '/paymentResult',
      ...options,
    })
    if (options.disableAutoRedirect && link) {
      window.open(link)
    }
  }

  switch (mode) {
    case 'payment':
      redirectHppForCheckout()
      break
    case 'recurring':
      redirectHppForRecurring()
      break
  }
}
